import React from 'react';
import validator from 'validator';
import ProgramForm from '../program/ProgramForm';
import GreenLeafApi from '../utils/GreenLeafApi';
import EditPage from '../EditPage';
import ContactType from '../utils/ContactType';
import CreateContactModal from '../teams/CreateContactModal';

class EditProgramPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isCreating: !props.match.params.programId,
      errors: {},
      error: null,
      showModal: false,
      program: {
        name: '',
        company_id: props.match.params.companyId,
        rte_id: ''
      },
      rte: null
    };
    this.saveProgram = this.saveProgram.bind(this);
    this.updateProgramState = this.updateProgramState.bind(this);
    this.getContacts = this.getContacts.bind(this);
    this.saveRte = this.saveRte.bind(this);
    this.selectRte = this.selectRte.bind(this);
    this.cancel = this.cancel.bind(this);
  }

  async componentDidMount() {
    try {
      if (!this.state.isCreating) {
        const programs = (await GreenLeafApi.Program.get({programId: this.props.match.params.programId})).data;
        this.setState({program: programs[0]});

        if (programs[0].rte_id) {
          let rte = (await GreenLeafApi.Contact.get({contactId: programs[0].rte_id})).data[0];
          if (rte) {
            rte.name = `${rte.first_name} ${rte.last_name}`;
            this.setState({rte: rte});
          }
        }
      }
    } catch (e) {
      this.setState({ error: e.errors });
    }
  }

  async saveProgram(event) {
    event.preventDefault();

    if(this.validate(this.state.program)) {
      try {
        if (this.state.isCreating) {
          await GreenLeafApi.Program.create(this.state.program);
        } else {
          await GreenLeafApi.Program.update(this.state.program);
        }

        this.props.history.goBack();
      } catch (e) {
        this.setState({ error: e.errors });
      }
    }
  }

  selectRte(rte) {
    if (rte && rte.id) {
      this.setState((prevState) => {
        prevState.rte = rte;
        prevState.program.rte_id = rte.id;

        return prevState;
      });
    } else {
      this.setState({ showModal: true, typeCreating: ContactType.RELEASE_TRAIN_ENGINEER });
    }
  }

  updateProgramState(event) {
    let errors = this.state.errors;
    const field = event.target.name;
    errors[field] = null;
    let state = { errors, program: this.state.program };
    state.program[field] = event.target.value;
    return this.setState(state);
  }

  getContacts(input) {
    if (!input) {
      return Promise.resolve({ options: [] });
    }

    input = input.split(' ');

    return GreenLeafApi.Contact.get(
      {
        companyId: this.props.match.params.companyId,
        firstName: `%25${input[0]}%25`,
        lastName: `%25${input[1] ? input[1] : ''}%25`
      })
      .then(options => {
        this.setState({ contacts: options.data });

        options.data.forEach(o => o.name = o.first_name + ' ' + o.last_name);

        return { options: options.data };
      });
  }

  async saveRte(contact) {
    contact.company_id = this.props.match.params.companyId;
    if (!contact.rte_id) {
      contact.rte_id = null;
    }
    try {
      let response = await GreenLeafApi.Contact.create(contact);

      let newContact = response.data;
      newContact.name = newContact.first_name + ' ' + newContact.last_name;

      this.setState((prevState) => ({
        program: {
          ...prevState.program,
          rte_id: newContact.id
        },
        rte: newContact,
        showModal: false
      }));
    } catch (e) {
      this.setState({ error: e.errors });
    }
  }

  cancel() {
    this.props.history.goBack();
  }

  validate() {
    const requiredFields = ['name'];
    let errors = {};
    requiredFields.forEach(f => {
      if (validator.isEmpty(this.state.program[f])) {
        errors[f] = 'This is a required field.';
      }
    });

    this.setState({errors: errors});
    return Object.keys(errors).length === 0;
  }

  render() {
    return (
      <div>
        <EditPage
          editType={'Program'}
          isCreating={this.state.isCreating}
          error={this.state.error}>
          <ProgramForm
            preset={this.state.program}
            errors={this.state.errors}
            onSave={this.saveProgram}
            onCancel={this.cancel}
            onChange={this.updateProgramState}
            selectRte={this.selectRte}
            rte={this.state.rte}
            getContacts={this.getContacts}/>
        </EditPage>

        { this.state.showModal &&
        <CreateContactModal
          show={this.state.showModal}
          handleClose={() => this.setState({ showModal: false })}
          onSave={this.saveRte}/>
        }
      </div>

    );
  }
}

export default EditProgramPage;


// WEBPACK FOOTER //
// ./src/components/program/EditProgramPage.js